const SearchFieldBtn = (): JSX.Element => {
  return (
    <div
      className={`search-field-btn bg-blue700 p-2 rounded-full self-center button focus:outline-none w-10 h-10 flex justify-center items-center absolute top-1/2 translate-y-1/2- 
       right-2
      `}
    >
      <img
        className="w-4 h-4"
        src={'/Images/Icons/search-icon.svg'}
        alt="Sök ikon"
        width={16}
        height={16}
        loading="lazy"
      />
    </div>
  );
};
export default SearchFieldBtn;
